import { theme } from '@dojo/framework/core/middleware/theme';
import { create, v, w } from '@dojo/framework/core/vdom';
import { TopicDetails } from '@holmescorp/lcc-state/interfaces';

import css from '../css/study.m.css';
import { MicroCard } from './mc-card';

export interface MicroCardsViewProperties {
	/* ** The list of topics to be displayed */
	topics: TopicDetails[];

	/* ** Any action taken on a card that triggers a view switch */
	onAction?: (data?: { [key: string]: any }) => void;
}

const factory = create({
	theme
}).properties<MicroCardsViewProperties>();

export const MicroCardsView = factory(({ id, properties, middleware: { theme } }) => {
	const { topics = [], onAction } = properties();
	const fixedCss = theme.classes(css);

	return v(
		'div',
		{ id, classes: [theme.variant(), fixedCss.cards] },
		topics
			? topics.map((topic) => {
					return w(MicroCard, { topic, onAction });
			  })
			: []
	);
});

export default MicroCardsView;
